export default "__VITE_ASSET__122b40a1__"